// Using IframeLevelTest to embed Content Layer assessment
import IframeLevelTest from './IframeLevelTest';

export default IframeLevelTest;
